import { computed, defineComponent, nextTick, ref, useContext, useCssModule } from '@nuxtjs/composition-api';
import { EXPAND_TRANSITION_DURATION } from './';
import { EDUCATIONS_PODCASTS } from '~/constants';
export default defineComponent({
    name: 'PodcastHeader',
    props: {
        podcast: {
            default: () => ({}),
            type: Object,
        },
        theme: {
            default: 'dark',
            type: String,
            validator(value) {
                return ['dark', 'light'].includes(value);
            },
        },
        withImage: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        /**
         * CSS Composables.
         */
        const css = useCssModule();
        const context = useContext();
        /**
         * Context variables.
         */
        const viewport = context.$viewport;
        const isExpanded = ref(false);
        const isEducation = computed(() => {
            return EDUCATIONS_PODCASTS.includes(context.route.value.params.podcast);
        });
        const entries = computed(() => {
            const items = [
                {
                    title: 'Подкасты',
                    to: '/podcasts',
                },
            ];
            if (isEducation.value) {
                items.unshift({
                    title: 'Forbes Education',
                    to: '/education/',
                });
            }
            return items;
        });
        const subscribeButtonSize = computed(() => {
            return viewport.isLessThan('tablet') ? 'default' : 'small';
        });
        function expandDescription(event) {
            if (viewport.isGreaterThan('desktopMedium')) {
                return;
            }
            isExpanded.value = true;
            let target = event.target;
            if (target.tagName !== 'P') {
                target = target.closest('p');
            }
            const { style } = target;
            nextTick(() => {
                style.maxHeight = target.scrollHeight + 'px';
                style.webkitLineClamp = 'unset';
                style.webkitBoxOrient = 'unset';
                style.display = 'block';
                style.cursor = 'auto';
                setTimeout(() => {
                    style.overflow = 'visible';
                    style.maxHeight = '100%';
                }, EXPAND_TRANSITION_DURATION);
            });
        }
        return {
            css,
            entries,
            isEducation,
            isExpanded,
            expandDescription,
            EXPAND_TRANSITION_DURATION,
            subscribeButtonSize,
        };
    },
});
